<template>
  <div>
    <div class="header_wrapper">
      <div class="header animate__animated animate__fadeInDown">
        <div class="nav navWidth">
          <img src="../../assets/imgs/logo.png" alt class="fl" align="absmiddle"/>
          <ul class="nav_url fl">
            <li class="white">
              <router-link
                to="/"
                exact
                @click.native="setActiveNav('home')"
                :class="{ current: currentActiveNav === 'home' && !isGameListActive }"
                :active-class="isGameListActive ? '' : 'router-link-active'"
                :exact-active-class="isGameListActive ? '' : 'router-link-exact-active'"
              >
                <div class="header-content"><span class="iconfont icon-shouye"></span><span>首&nbsp;&nbsp;&nbsp;&nbsp;頁</span></div>
              </router-link>
            </li>
            <!--          <li class="white">-->
            <!--            <router-link to="/barrageGame">-->
            <!--              <div class="header-content"><span>彈幕遊戲</span></div>-->
            <!--            </router-link>-->
            <!--          </li>-->
            <li class="white">
              <router-link to="/partners" @click.native="setActiveNav('partners')">
                <div class="header-content"><span class="iconfont icon-iphone1"></span><span>合作廠商</span></div>
              </router-link>
            </li>
            <li class="white">
              <a href="javascript:;" @click="gotoNewGame" :class="{ current: currentActiveNav === 'gameList' }">
                <div class="header-content"><span class="iconfont icon-game1" style="font-size:30px"></span><span>遊戲列表</span></div>
              </a>
            </li>
            <li class="white">
              <router-link to="/gameStoreCenter" @click.native="setActiveNav('gameStoreCenter')">
                <div class="header-content"><span class="iconfont icon-qiandaizi-copy" style="font-size:30px"></span><span>儲值中心</span></div>
              </router-link>
            </li>
            <li class="white">
              <router-link to="/memberCenter" @click.native="setActiveNav('memberCenter')">
                <div class="header-content"><span class="iconfont icon-huiyuanzhongxin"></span><span>會員中心</span></div>
              </router-link>
            </li>
            <li class="white">
              <router-link to="/customerCenter" @click.native="setActiveNav('customerCenter')">
                <div class="header-content"><span class="iconfont icon-kefuzhongxin1"></span><span>客服中心</span></div>
              </router-link>
            </li>
          </ul>
          <span ref="userIcon" class="iconfont icon-yonghu cursor" @click="toggleUserMenu" v-if="token"></span>
          <a href="javascript:;" class="login"  @click="showLoginDialog" v-else></a>
        </div>

      </div>
    </div>
    <transition name="slide-down-up">
      <ul ref="userMenu" class="ul_select cursor" :style="menuStyle" v-if="isShowSelect">
        <li @click="loginOut">登出</li>
        <li @click="accountCancel">註銷帳戶</li>
      </ul>
    </transition>
  </div>

</template>

<script>

export default {
  name: "CommonNav",
  props: {
    options: Object,
  },
  data: function () {
    return {
      isAni: false,
      isShowSelect: false,
      isClosing: false,
      menuStyle: {
        position: 'absolute',
        left: '0px',
        top: '94px',
        visibility: 'hidden'
      },
      currentActiveNav: 'home', // 当前激活的导航项，默认为首页
      isGameListActive: false // 标记是否通过游戏列表导航激活
    };
  },
  mounted() {
    this.isAni = true;
    // 根据当前路由设置激活导航
    this.updateActiveNavByRoute();
    // 绑定事件以在窗口变化时重新计算菜单位置
    this.__computeMenuBound = this.computeMenuPosition.bind(this);
    window.addEventListener('resize', this.__computeMenuBound);
    window.addEventListener('scroll', this.__computeMenuBound, true);
    // 点击外部关闭
    this.__onDocClick = (e) => {
      const icon = this.$refs.userIcon;
      const menu = this.$refs.userMenu;
      if (!icon || !menu) return;
      if (this.isShowSelect) {
        if (!icon.contains(e.target) && !menu.contains(e.target)) {
          this.startCloseAnimation();
        }
      }
    };
    document.addEventListener('click', this.__onDocClick);

    // attach hover listeners to #HomeLatestGame (may be rendered later) with retries
    this.__attachHomeLatestGameHover = () => {
      let tries = 0;
      const tryAttach = () => {
        const el = document.getElementById('HomeLatestGame');
        if (el) {
          this.__homeLatestGameEl = el;
          el.addEventListener('mouseenter', this.onHomeLatestGameEnter);
          el.addEventListener('mouseleave', this.onHomeLatestGameLeave);
        } else if (tries < 10) {
          tries++;
          setTimeout(tryAttach, 300);
        }
      };
      tryAttach();
    };
    this.__attachHomeLatestGameHover();
    // attach hover listeners to #mainSwiper to restore home highlight when hovered
    this.__attachMainSwiperHover = () => {
      let tries = 0;
      const tryAttach = () => {
        const el = document.getElementById('mainSwiper');
        if (el) {
          this.__mainSwiperEl = el;
          el.addEventListener('mouseenter', this.onMainSwiperEnter);
          el.addEventListener('mouseleave', this.onMainSwiperLeave);
        } else if (tries < 10) {
          tries++;
          setTimeout(tryAttach, 300);
        }
      };
      tryAttach();
    };
    this.__attachMainSwiperHover();
    // document-level hover fallback to handle timing/structure issues
    this.__onDocHover = (e) => {
      try {
        // only apply hover-driven highlight when on home route
        if (!(this.$route.path === '/' || this.$route.path === '/home')) return;
        const homeLatest = document.getElementById('HomeLatestGame');

        // If we're hovering inside HomeLatestGame, mark game list active.
        if (homeLatest && homeLatest.contains(e.target)) {
          this.currentActiveNav = 'gameList';
          this.isGameListActive = true;
          return;
        }

        // Not hovering HomeLatestGame -> restore home highlight
        this.currentActiveNav = 'home';
        this.isGameListActive = false;
      } catch (err) {
        // ignore
      }
    };
    document.addEventListener('mouseover', this.__onDocHover);

    // IntersectionObserver to sync nav highlight based on scroll position
    this.__navObserverTries = 0;
    const tryNavObserve = () => {
      const homeLatest = document.getElementById('HomeLatestGame');
      const mainSwiper = document.getElementById('mainSwiper');
      if (!homeLatest && !mainSwiper && this.__navObserverTries < 10) {
        this.__navObserverTries++;
        setTimeout(tryNavObserve, 300);
        return;
      }

      const opts = { root: null, rootMargin: '0px', threshold: [0.2] };
      this.__navObserver = new IntersectionObserver((entries) => {
        // only affect highlight switching when on home route
        if (!(this.$route.path === '/' || this.$route.path === '/home')) return;
        let homeVisible = false;
        let mainVisible = false;
        entries.forEach(ent => {
          if (!ent.target) return;
          if (ent.target.id === 'HomeLatestGame') homeVisible = homeVisible || ent.isIntersecting;
          if (ent.target.id === 'mainSwiper') mainVisible = mainVisible || ent.isIntersecting;
        });

        if (homeVisible) {
          this.currentActiveNav = 'gameList';
          this.isGameListActive = true;
        } else if (mainVisible) {
          this.currentActiveNav = 'home';
          this.isGameListActive = false;
        }
      }, opts);

      if (homeLatest) this.__navObserver.observe(homeLatest);
      if (mainSwiper) this.__navObserver.observe(mainSwiper);

      // initial check
      if (this.$route.path === '/' || this.$route.path === '/home') {
        if (homeLatest) {
          const r = homeLatest.getBoundingClientRect();
          const visible = r.top < window.innerHeight && r.bottom > 0;
          if (visible) {
            this.currentActiveNav = 'gameList';
            this.isGameListActive = true;
          }
        }
        if (!this.isGameListActive && mainSwiper) {
          const r2 = mainSwiper.getBoundingClientRect();
          const visible2 = r2.top < window.innerHeight && r2.bottom > 0;
          if (visible2) {
            this.currentActiveNav = 'home';
            this.isGameListActive = false;
          }
        }
      }
    };
    tryNavObserve();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.__computeMenuBound);
    window.removeEventListener('scroll', this.__computeMenuBound, true);
    document.removeEventListener('click', this.__onDocClick);
    // cleanup home latest game hover
    if (this.__homeLatestGameEl) {
      this.__homeLatestGameEl.removeEventListener('mouseenter', this.onHomeLatestGameEnter);
      this.__homeLatestGameEl.removeEventListener('mouseleave', this.onHomeLatestGameLeave);
      this.__homeLatestGameEl = null;
    }
    // cleanup main swiper hover
    if (this.__mainSwiperEl) {
      this.__mainSwiperEl.removeEventListener('mouseenter', this.onMainSwiperEnter);
      this.__mainSwiperEl.removeEventListener('mouseleave', this.onMainSwiperLeave);
      this.__mainSwiperEl = null;
    }
    if (this.__onDocHover) {
      document.removeEventListener('mouseover', this.__onDocHover);
      this.__onDocHover = null;
    }
    if (this.__navObserver) {
      this.__navObserver.disconnect();
      this.__navObserver = null;
    }
  },
  watch: {
    '$route': function(to, from) {
      // 当路由变化时，只有在不是游戏列表激活状态下才自动更新导航高亮
      if (!this.isGameListActive) {
        this.updateActiveNavByRoute();
      }
    }
  },
  computed:{
    token (){
      return this.$store.state.token;
    }
  },
  methods: {
    showLoginDialog: function () {
      this.$emit("showLoginDialog");
    },
    toggleUserMenu() {
      if (!this.isShowSelect) {
        this.isShowSelect = true;
        this.menuStyle.visibility = 'visible';
        this.$nextTick(() => {
          this.computeMenuPosition();
        });
      } else {
        // hide via v-if to trigger transition leave
        this.isShowSelect = false;
      }
    },
    onHomeLatestGameEnter() {
      // when hovering the HomeLatestGame section, highlight the game list nav
      this.currentActiveNav = 'gameList';
      this.isGameListActive = true;
    },
    onHomeLatestGameLeave() {
      // when leaving, restore home highlight
      this.currentActiveNav = 'home';
      this.isGameListActive = false;
    },
    onMainSwiperEnter() {
      // when hovering main swiper, show home highlight
      this.currentActiveNav = 'home';
      this.isGameListActive = false;
    },
    onMainSwiperLeave() {
      // no-op or could restore previous state
    },
    startCloseAnimation() {
      // keep for backward calls: simply set isShowSelect false to trigger leave
      if (!this.isShowSelect) return;
      this.isShowSelect = false;
    },
    onMenuAfterLeave() {
      // Vue transition finished leaving
      this.menuStyle.visibility = 'hidden';
    },
    computeMenuPosition() {
      const icon = this.$refs.userIcon;
      const menu = this.$refs.userMenu;
      if (!icon || !menu) return;

      const iconRect = icon.getBoundingClientRect();
      const menuRect = menu.getBoundingClientRect();

      // 计算左边让菜单水平中点对齐图标中心（使用 viewport 坐标，position: fixed）
      const left = iconRect.left + (iconRect.width / 2) - (menuRect.width / 2);
      // 顶部放在图标底部
      const top = iconRect.bottom;

      this.menuStyle = Object.assign({}, this.menuStyle, {
        position: 'absolute',
        left: Math.round(left) + 'px',
        top:  '94px',
        visibility: (this.isShowSelect) ? 'visible' : 'hidden'
      });
    },
    setActiveNav: function(navKey) {
      this.currentActiveNav = navKey;
      this.isGameListActive = false; // 重置游戏列表激活状态
    },
    gotoNewGame: function () {
      // 设置游戏列表为激活状态
      this.currentActiveNav = 'gameList';
      this.isGameListActive = true;

      // 检查当前路由是否为首页
      if (this.$route.path === '/' || this.$route.path === '/home') {
        // 如果在首页，直接滚动到游戏列表
        this.scrollToGameList();
      } else {
        // 如果不在首页，先跳转到首页，然后滚动到游戏列表
        this.$router.push('/').then(() => {
          // 使用 nextTick 确保页面完全加载后再滚动
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollToGameList();
            }, 300); // 延迟300ms确保页面元素完全渲染
          });
        });
      }
    },
    scrollToGameList() {
      const element = document.getElementById("HomeLatestGame");
      if (element) {
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const elementTop = rect.top + scrollTop;

        // PC端头部导航高度约为93.14px
        // const headerHeight = 93.14;// 如果固定头部高度fixed
        const headerHeight = 0
        const targetPosition = elementTop - headerHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    },
    updateActiveNavByRoute: function() {
      const path = this.$route.path;
      // 重置游戏列表激活状态
      this.isGameListActive = false;

      if (path === '/' || path === '/home') {
        this.currentActiveNav = 'home';
      } else if (path === '/partners') {
        this.currentActiveNav = 'partners';
      } else if (path === '/gameStoreCenter') {
        this.currentActiveNav = 'gameStoreCenter';
      } else if (path === '/memberCenter') {
        this.currentActiveNav = 'memberCenter';
      } else if (path === '/customerCenter') {
        this.currentActiveNav = 'customerCenter';
      } else {
        this.currentActiveNav = '';
      }
    },
    accountCancel: function (){
      this.$emit('accountCancel');
      this.startCloseAnimation();
    },
    loginOut: function () {
      this.$emit("loginOut");
      this.startCloseAnimation();
    }
  },
};
</script>

<style lang="stylus" scoped>
/* * slide-fade animate */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.slide-down-up-enter-active,
.slide-down-up-leave-active {
  transition: all 0.22s cubic-bezier(.2, .9, .2, 1);
}

.slide-down-up-enter {
  opacity: 0;
  transform: translateY(-20px) scaleY(0.8);
}

.slide-down-up-enter-to {
  opacity: 1;
  transform: translateY(0) scaleY(1);
}

.slide-down-up-leave {
  opacity: 1;
  transform: translateY(0) scaleY(1);
}

.slide-down-up-leave-to {
  opacity: 0;
  transform: translateY(-20px) scaleY(0.8);
}

.ul_select {
  position: absolute;
  width: 139px;
  height: 107px;
  z-index 1;
  background-color: #ffffff;
  box-shadow: 0px 1px 3px 0px rgba(34, 24, 21, 0.35);
  border-radius: 5px;

  li {
    width 90%
    margin 0 auto
    text-align center
    height 53px
    line-height: 53px;
    transition color .6s
    &:hover{
      font-weight: 700
      color: #fcc814;
    }
    a{
      color: #fcc916;
    }

    &:nth-child(1) {
      border-bottom 1px solid #333333;
    }
  }
}

.icon-yonghu{
  display inline-block
  position relative
  top:50%
  left: 91.7%;
  transform translate(0, -50%)
  cursor pointer
}
.logined{
  /* wrapper no longer forces absolute position; menu will be positioned in document by JS */
  width: 155px;
  height: 50px;
  position: absolute;
  z-index: 1;

  ul{
    position: absolute; /* will be placed by inline style from Vue */
    width: 139px;
    height: auto;
    z-index: 9999;
    background-color: #ffffff;
    box-shadow: 0px 1px 3px 0px rgba(34, 24, 21, 0.35);
    border-radius: 5px;
    /* Remove generic transition to avoid conflicting with keyframe animations */
    transition: none;
    visibility: hidden;
    transform-origin: center top;
    will-change: transform, opacity;
    transform: translateZ(0);
    overflow: hidden;

    &.slide-down {
      transform-origin: top center;
      animation: slideDown .22s cubic-bezier(.2, .9, .2, 1) forwards;
      visibility: visible;
    }

    &.slide-up {
      transform-origin: bottom center;
      /* smooth upward shrink */
      animation: slideUp .22s cubic-bezier(.2, .9, .2, 1) forwards;
      visibility: visible;
    }
    li{
      width: 93%;
      margin:0 auto;
      height: 45px;
      line-height: 45px;
      text-align: center;
      border-bottom: 1px solid #9d9d9d;
      cursor: pointer;
      background: transparent;
      &:nth-child(1){
        border-bottom 1px solid #333333;
      }
      &:hover{
        color: #fcc916;
      }
    }
  }

  /* Vue transition classes for slide-down-up */

  .slide-down-up-enter-active,
  .slide-down-up-leave-active {
    transition: transform .22s cubic-bezier(.2, .9, .2, 1), opacity .18s linear;
    transform-origin: bottom center;
    will-change: transform, opacity;
  }

  .slide-down-up-enter-from {
    opacity: 0;
    transform: scaleY(0);
  }

  .slide-down-up-enter-to {
    opacity: 1;
    transform: scaleY(1);
  }

  .slide-down-up-leave-from {
    opacity: 1;
    transform: scaleY(1);
  }

  .slide-down-up-leave-to {
    opacity: 0;
    transform: scaleY(0);
  }

  @keyframes slideDown {
    0% {
      opacity: 0;
      transform: scaleY(0);
    }
    100% {
      opacity: 1;
      transform: scaleY(1);
    }
  }

  @keyframes slideUp {
    0% {
      opacity: 1;
      transform: scaleY(1);
    }
    100% {
      opacity: 0;
      transform: scaleY(0);
    }
  }
}

.header_wrapper {
  width: 100%;
  height: 93.14px;
  background: #202020;
}

.header {
  position: relative;
  top: 0;
  z-index: 2;
  //min-width: 1250px;
  width: 100%;
  height: 93.14px;
  background: #4b4a47;
  box-shadow: 0 -3px 3px 0 rgba(0, 0, 0, 0.75) inset;

  .login{
    width: 155px;
    height: 50px;
    position: absolute;
    right: 0;
    top: calc(50% - 25px);
    background: url('../../assets/imgs/dawudao/btn_login.png') no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    transition all 0.1s ease-in;
    &:hover{
      transform scale(1.05) translateY(-1px)
    }
  }
  .navWidth {
    width: 1400px;
    margin: 0 auto;
  }

  .nav {
    position: relative;
    height: 100%;

    img {
      vertical-align: middle;
      width: 248px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    ul.nav_url {
      position: absolute;
      left: 338px;
      display: flex;
      flex-wrap: nowrap;

      li {
        width: 150px;
        height: 93.14px;
        line-height: 93.14px;
        text-align: center;

        &.current {
          background: #3a3a3a;
        }

        .header-content {
          display: inline-block;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 150px;
          height: 100%;
        }

        &:nth-child(1) {
          .header-content:hover {
            &::before {
              width: 40px;
              height: 35px;
              background-position: -260px -37px !important;
            }
          }
        }

        &:nth-child(2) {
          .header-content:hover {
            &::before {
              width: 26px;
              height: 48px;
              margin-top: -24px !important;
              background-position: -166px 0px !important;
            }
          }
        }

        &:nth-child(3) {
          .header-content:hover {
            &::before {
              width: 43px;
              height: 40px;
              background-position: -98px -45px !important;
            }
          }
        }

        &:nth-child(4) {
          .header-content:hover {
            &::before {
              width: 31px;
              height: 30px;
              background-position: -57px -96px !important;
            }
          }
        }

        &:nth-child(5) {
          .header-content:hover {
            &::before {
              width: 25px;
              height: 37px;
              background-position: -56px -3px !important;
            }
          }
        }

        &:nth-child(6) {
          .header-content:hover {
            &::before {
              width: 32px;
              height: 36px;
              background-position: -53px -137px !important;
            }
          }
        }

        &.white {
          &:nth-child(1) {
            .header-content {
              &::before {
                width: 40px;
                height: 35px;
                background-position: -2px -45px;
              }
            }
          }

          &.white {
            &:nth-child(2) {
              .header-content {
                &::before {
                  width: 26px;
                  height: 48px;
                  margin-top: -24px !important;
                  background-position: -166px -58px;
                }
              }
            }
          }

          &.white {
            &:nth-child(3) {
              .header-content {
                &::before {
                  width: 43px;
                  height: 40px;
                  background-position: -98px -3px;
                }
              }
            }
          }

          &:nth-child(4) {
            .header-content {
              &::before {
                width: 31px;
                height: 35px;
                background-position: -2px -90px;
              }
            }
          }

          &:nth-child(5) {
            .header-content {
              &::before {
                width: 25px;
                height: 37px;
                background-position: 0px 0px;
              }
            }
          }

          &:nth-child(6) {
            .header-content {
              &::before {
                width: 32px;
                height: 36px;
                background-position: -6px -134px;
              }
            }
          }

        }

        &:nth-child(1) {
          a.current {
            span {
              color: #4b4a47;
            }

            .header-content::before {
              width: 40px;
              height: 35px;
              background-position: -260px -37px;
            }
          }
        }


        &:nth-child(2) {
          a.current {
            span {
              color: #4b4a47;
            }

            .header-content::before {
              width: 26px;
              height: 48px;
              background-position: -166px 0px !important;
            }
          }
        }

        &:nth-child(3) {
          a.current {
            span {
              color: #4b4a47;
            }

            .header-content::before {
              width: 43px;
              height: 40px;
              background-position: -98px -45px !important;
            }
          }
        }


        &:nth-child(4) {
          a.current {
            span {
              color: #4b4a47;
            }

            .header-content::before {
              width: 31px;
              height: 35px;
              background-position: -57px -95px;
            }
          }
        }

        &:nth-child(5) {
          a.current {
            span {
              color: #4b4a47;
            }

            .header-content::before {
              width: 25px;
              height: 37px;
              background-position: -56px -3px;
            }
          }
        }

        &:nth-child(6) {
          a.current {
            span {
              color: #4b4a47;
            }

            .header-content::before {
              left: 11%;
              width: 32px;
              height: 36px;
              background-position: -53px -137px;
            }
          }
        }

        a {
          width: 100%;
          height: 100%;
          display: inline-block;
          color: #9d9d9d;
          position: relative;

          i {
            display: inline-block;
            width: 27px;
            height: 25px;
            background: url('../../assets/imgs/icon.png') no-repeat center;
            background-size: 300px 300px;
            background-position: 0 0;
            vertical-align: middle;
          }

          &:hover {
            transition: background 0.3s ease-in;
            background: #fcc916;
            box-shadow: 0 -3px 3px 0 rgba(0, 0, 0, 0.75) inset;

            span {
              color: #4b4a47;
            }
          }

          &.current {
            background: #fcc916;
            color: #4b4a47;
            box-shadow: 0 -3px 3px 0 rgba(0, 0, 0, 0.75) inset;
          }

          &.router-link-active,
          &.router-link-exact-active {
            background: #fcc916;
            color: #4b4a47;
            box-shadow: 0 -3px 3px 0 rgba(0, 0, 0, 0.75) inset;

            span {
              color: #4b4a47;
            }
          }

          &.active {
            color: #fff;

            span {
              color: #fff;
              font-size: 26px;
            }
          }

          span {
            color: #ffffff;
            font-size: 22.14px;
          }
        }
      }
    }
  }
}
</style>
© 2018 Gogs 当前版本: 0.11.66.0916 页面: 49ms 模板: 1m
